import React, { useEffect, useRef, useState, useContext } from "react";

import { Accordion, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Swal from 'sweetalert2'

import useShopeRegistration from "../../hooks/useShopRegistration";


import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useOnboarding } from "../../context/OnboardingContext";
import { SubmitHandler, useForm } from "react-hook-form";
import useBank from "../../hooks/useBank";
import useSellerPackage from "../../hooks/useSellerSelectionPackage";


const schema = yup.object({
    packageId: yup.string().required(),
    bankTransferId: yup.string().required(),
}).required();

const RegPayment_Summary = () => {
    const navigate = useNavigate();

    

     const { fetchActiveBank, data: activeBank } = useBank();
     const { fetchPackage, data:sellerPackages } = useSellerPackage();
    const [activeKey, setActiveKey] = useState('0');
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedBankValue, setSelectedBankValue] = useState(null);
    const {saveStep,saveQris, data, qris, clear } = useOnboarding(); 
     
    //console.log(sellerPackages);
    const { sentCustomerShopCreate: subscribeShop } = useShopeRegistration();

    const DatatoSent={
         bussinesstype: data.bussinesstype ?? "",
        ownerName: data.ownerName ?? "",
        citizenID: data.citizenID ?? "",
        agreement: data.agreement ?? false,
        email: data.email ?? "",
        shopName: data.shopName ?? "",
        phone: data.phone ?? "",
        phoneCC: data.phone ?? "+62"
    }


    const handleRadioClick = (e, value) => {
        e.stopPropagation(); // Crucial: Prevents the click from reaching the accordion toggle
        setSelectedValue(value);
        
        //console.log(value)

    };

    const handleBankClick =(e, value)=>{
        setSelectedBankValue(value);
    }

    // This function handles the accordion toggle (optional, can be managed by activeKey alone)
    const handleAccordionToggle = (eventKey) => {
        setActiveKey(eventKey);
    };

    const accordionItems = [
        { eventKey: '0', header: 'Item #1', body: 'Content for item 1.' },
        { eventKey: '1', header: 'Item #2', body: 'Content for item 2.' },
        { eventKey: '2', header: 'Item #3', body: 'Content for item 3.' },
    ];

    const onSubmit = async (data) => {
        // await api.post("/register/complete", data);
        // clear();
        // navigate("/registration-seller-completed");

        const payload = {
            ...data, // onboarding data
            userId: JSON.parse(localStorage.getItem('user')).id,
            packageId: data.packageId,
            bankTransferId: data.bankTransferId,
        };

        
         
        console.log(payload)
            try {
                const result = await subscribeShop(payload);
                //console.log(result);
                Swal.fire({
                    title: "Success",
                    text: "Register successfully",
                    icon: "success"
                });
                if(result=="success!"){
                    console.log(result)
                    saveQris({
                        qrisImage: selectedBankValue.qris
                    });
                  
                    console.log(qris)
                }
                
                navigate("/registration-seller-completed");

                
            } catch (err) {
                //console.log(err);
                Swal.fire({
                    title: "Error",
                    text: err,
                    icon: "error"
                });
            }
    };

    const readUserData=()=> {
        if(localStorage.getItem('user')==null){
            navigate("/login")
        } 
    }


    useEffect(() => {
        readUserData();
        fetchPackage();
        fetchActiveBank();
    },[]);

    const {
                 register,
                 handleSubmit,
                 reset,
                 
                 setValue,
                 formState: { errors }
             } = useForm({
                 resolver: yupResolver(schema),
                  defaultValues: {
                      bussinesstype: data.bussinesstype ?? "",
                        ownerName: data.ownerName ?? "",
                        citizenID: data.citizenID ?? "",
                        agreement: data.agreement ?? false,
                        email: data.email ?? "",
                        shopName: data.shopName ?? "",
                        phone: data.phone ?? "",
                        phoneCC: data.phone ?? "+62"
                 }
             });
    
    

    return (
        <div className="payment_summary text_quicksand">
            <div className="container">

                <div className="card mb-40">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Shop Name</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.shopName}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6  mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Email</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.email}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Bussiness Type</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.bussinesstype === 0 ? "Personal" : "Company"}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Phone Number</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.shopName}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="title text_quicksand fw-bold text-32 text-black">
                    <span>Plan</span>
                </div>
                <form  onSubmit={handleSubmit(onSubmit)}>
                    <div className="mx-auto mb-70 mt-70" style={{}}>
                        <Accordion defaultActiveKey="0">
                            
                            

                             {
                            sellerPackages.map((item, index) => (
                                        <Accordion.Item eventKey={String(index )} className={selectedValue?.index === String(index ) ? 'accordion-item-selected' : ''}>
                                <Accordion.Header>
                                    <span className="position-relative">
                                        <Form.Check
                                            type="radio"
                                            // id={`radio-`+String(index + 3)}
                                            // name="plan_selection"
                                            {...register("packageId")} 
                                            value={String(item.id)}
                                            checked={selectedValue?.index === String(index )}
                                            onChange={() => { }} // dummy onChange as actual state update is in onClick
                                            onClick={(e) => handleRadioClick(e, {index:String(index ), id:item.id, price:item.monthlyPrice} )}
                                            className="ms-3 custom-circular-checkbox-red"
                                            // Ensure the label text is clear for accessibility
                                            aria-label={`Select item `+ String(index )}
                                        />
                                        {/* <span className="" style={{width:"16px", height:"16px", backgroundColor:"red", top:"50%", left:"50%", transform:"translate(-50%)"}}></span> */}
                                    </span>

                                    <span className="d-flex justify-content-between align-items-center px-16 w-100">
                                        <span className="row-cols-1">
                                            <span className="d-block fw-bold text-18 mb-5">{item.name}</span>
                                            <span className="d-block text-14" style={{ color: "#666666" }}>{item.description}</span>
                                        </span>
                                        <span className="fw-bold text-18 ">
                                            $ {item.monthlyPrice} / Month
                                        </span>
                                    </span>


                                </Accordion.Header>
                                <Accordion.Body className="px-52 pt-0">
                                    <span className="row row-cols-1 row-cols-md-2 w-100 text-14 border-top pt-20">
                                        {
                                            item.descriptionList.map((desc, ind) => (
                                                 <span className="d-flex gap-5 align-items-center mb-10">
                                                    <i class="ph-duotone ph-check-circle" style={{ color: "#299e60" }}></i>
                                                    <span>{desc}</span>
                                                </span>
                                            ))
                                        }
                                        
                                    </span>
                                </Accordion.Body>
                            </Accordion.Item>
                                        
                                    ))
                                }

                        </Accordion>
                    </div>


                    <div className="card mb-40" >
                        <div className="card-body">
                            <div className="mb-20">
                                <span className="text-20 fw-bold">Payment Details</span>
                            </div>
                            <div>
                                <div className="d-flex justify-content-between mb-10 text-16">
                                    <span className="">Order Subtotal</span>
                                    <span>${selectedValue ? (selectedValue.price ? selectedValue.price.toFixed(2) : "0.00" )  : "0.00"}</span>
                                </div>
                                <div className="d-flex justify-content-between  mb-10 text-16 d-none">
                                    <span className="">Delivery Fee</span>
                                    <span>$1000.00</span>
                                </div>
                                <div className="d-flex justify-content-between mb-10 text-16  d-none">
                                    <span className="">Delivery Discount</span>
                                    <span className="text-danger">-$5.00</span>
                                </div>
                            </div>
                            <hr />
                            <div className="mb-20">
                                <div className="d-flex justify-content-between mb-10 text-16 fw-bold">
                                    <span className="">Order Subtotal</span>
                                   <span>${selectedValue ? (selectedValue.price ? selectedValue.price.toFixed(2) : "0.00" )  : "0.00"}</span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="payment-method mb-80">
                        <div className="text-20 fw-bold mb-40" style={{ color: "#1A1A1A" }}>
                            <span>
                                Payment Method
                            </span>
                        </div>
                        {/* <Tab.Container id="left-tabs-example" className="d-none" defaultActiveKey="home">
                          
                            <Nav variant="pills" className="d-flex align-items-center gap-20 mb-40">
                                <Nav.Item>
                                    <Nav.Link eventKey="banktransfer">Bank Transfer</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="creditcard">Credit Card</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="paynow">Paynow</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey="banktransfer">
                                    <div className="">
                                        <label className="d-flex align-items-center gap-24 mb-32">
                                            <span className="position-relative">
                                                <Form.Check
                                                    type="radio"
                                                    id={`radio-0`}
                                                    name="banks"
                                                    value={0}
                                                    className="ms-3 custom-circular-checkbox-red"
                                                    // Ensure the label text is clear for accessibility
                                                    aria-label={`Select item 0`}
                                                />
                                            </span>
                                            <div className="bank-photo-frame flex-center" >
                                                <img src="assets/images/payment/bca.png" className="w-100" />
                                            </div>
                                            <span className="text-16 fw-bold" style={{ color: "##40494C" }}>Bank Lorem Ipsum</span>
                                        </label>
                                        <label className="d-flex align-items-center gap-24 mb-32">
                                            <span className="position-relative">
                                                <Form.Check
                                                    type="radio"
                                                    id={`radio-0`}
                                                    name="banks"
                                                    value={1}
                                                    className="ms-3 custom-circular-checkbox-red"
                                                    // Ensure the label text is clear for accessibility
                                                    aria-label={`Select item 0`}
                                                />
                                            </span>
                                            <div className="bank-photo-frame flex-center" >
                                                <img src="assets/images/payment/bni.png" className="w-100" />
                                            </div>
                                            <span className="text-16 fw-bold" style={{ color: "##40494C" }}>Bank Lorem Ipsum</span>
                                        </label>
                                        <label className="d-flex align-items-center gap-24 mb-32">
                                            <span className="position-relative">
                                                <Form.Check
                                                    type="radio"
                                                    id={`radio-0`}
                                                    name="banks"
                                                    value={1}
                                                    className="ms-3 custom-circular-checkbox-red"
                                                    // Ensure the label text is clear for accessibility
                                                    aria-label={`Select item 0`}
                                                />
                                            </span>
                                            <div className="bank-photo-frame flex-center" >
                                                <img src="assets/images/payment/permata.png" className="w-100" />
                                            </div>
                                            <span className="text-16 fw-bold" style={{ color: "##40494C" }}>Bank Lorem Ipsum</span>
                                        </label>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="creditcard">
                                    <h3>Profile Content</h3>
                                    <p>This is the content for the profile section.</p>
                                </Tab.Pane>
                                <Tab.Pane eventKey="paynow">
                                    <h3>Settings Content</h3>
                                    <p>This is the content for the settings section.</p>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container> */}
                        <div className="bank-content">
                             {activeBank.map(
                                (bank, index) => (
                                        <label className="d-flex align-items-center gap-24 mb-32">
                                            <span className="position-relative">
                                                <Form.Check
                                                    type="radio"
                                                    id={`bankSelection-`+String(bank + 3)}
                                                    // name="banks"
                                                    {...register("bankTransferId")}
                                                    value={bank.id}
                                                    onClick={(e) => handleBankClick(e, {index:String(index ), id:bank.id, qris:bank.image} )}
                                                    className="ms-3 custom-circular-checkbox-red"
                                                    // Ensure the label text is clear for accessibility
                                                    aria-label={`Select item `+String(bank + 3)}
                                                />
                                            </span>
                                            <div className="bank-photo-frame flex-center" >
                                                <img src={bank.logo} className="w-100" />
                                            </div>
                                            <span className="text-16 fw-bold" style={{ color: "##40494C" }}>{bank.bankName}</span>
                                        </label>
                                )
                            )}
                                        
                                        
                        </div>
                    </div>

                    <div className="d-flex justify-content-between">
                        {/* <button className="btn btn_mart_secondary" onClick={() => navigate("/registration-shop-information")}>Previous</button>
                        <button className="btn btn_mart_primary" onClick={() => navigate("/registration-seller-completed")}>Next</button> */}
                         <button className="btn btn_mart_secondary" type="button" onClick={() => navigate("/registration-shop-information")}>Previous</button>
                        <button className="btn btn_mart_primary" type="submit" >Next</button>
                    </div>
                </form>

            </div>
        </div>
    );
};

export default RegPayment_Summary;